import {PortalType} from "@studyportals/domain-client";
import type { H3Event } from "h3";

const portalTypeMap: Record<string, PortalType> = {
	'master': PortalType.MASTER,
	'bachelor': PortalType.BACHELOR,
	'phd': PortalType.PHD,
	'short': PortalType.SHORT,
	'distance_learning': PortalType.DISTANCE_LEARNING,
};

export const getPortalTypeFromEnvServer = (event?: H3Event): PortalType => {
	const portalTypeStr =
		event?.context.portal?.portalType
		|| process.env.NUXT_PUBLIC_PORTAL_TYPE
		|| 'master';
	return portalTypeMap[portalTypeStr.toLowerCase()] || PortalType.MASTER;
};
